<template>
    <a v-if="user.type === 'pro'" :href="user.storefront_url" class="w-9 h-9 mr-4">
        <!-- <svg-vue icon="avatar" class=" w-9 h-9 inline-block mr-4 default-avatar-icon hover:cursor-default" /> -->
        <img
            v-show="!showingDefaultAvatar"
            @load="showingDefaultAvatar = false"
            :src="user.avatar_uri"
            :alt="`${user.display_name}'s avatar`"
            class="w-9 h-9 rounded-full max-w-none default-avatar-icon"
            :class="user.care_score > 3
                                        ? user.care_score >= 4
                                            ? 'badgeBlue'
                                            : 'badgeGreen'
                                        : '' "
        />
        <svg-vue
            v-show="showingDefaultAvatar"
            icon="circle-user"
            title="default user avatar"
            class="h-9 hover:cursor-pointer"
            :class="user.care_score > 3
                                    ? user.care_score >= 4
                                        ? 'fill-salesium-blue'
                                        : 'fill-salesium-green'
                                    : '' "
        />
    </a>
    <span v-else class="w-9 h-9 mr-4">
        <img
            v-show="!showingDefaultAvatar"
            @load="showingDefaultAvatar = false"
            :src="user.avatar_uri"
            :alt="`${user.display_name}'s avatar`"
            class="w-9 h-9 rounded-full max-w-none default-avatar-icon"
        />
        <svg-vue
            v-show="showingDefaultAvatar"
            icon="circle-user"
            title="default user avatar"
            class="h-9"
        />
    </span>
</template>

<script>
export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
        showingDefaultAvatar: {
            type: Boolean,
            required: false,
        }
    },
    name: "UserNameRef"
}
</script>

<style scoped>

</style>
